import { MenuNode } from "src/app/sessions/common/dealer-menu/dealer-menu.component";
import { TransactionStage } from "./common-basic-data";

export enum MenuCode {
    DASHBOARD = "DASHBOARD",

    
    CAR = "CAR",
    CAR_PROVIDERS_FAV = "CAR_PROVIDERS_FAV",
    CAR_ALERT = "CAR_ALERT",

    CAR_PARK = "CAR_PARK",
    CAR_PARK_POSTING_TO_PROCESS = "CAR_PARK_POSTING_TO_PROCESS",
    CAR_PARK_POSTING_PROCESSED = "CAR_PARK_POSTING_PROCESSED",
    CAR_PARK_CARS = "CAR_PARK_CARS",
    
    CAR_REPAIR = "CAR_REPAIR",
    CAR_REPAIR_DRAFT = "CAR_REPAIR_DRAFT",
    CAR_REPAIR_PENDING = "CAR_REPAIR_PENDING",
    CAR_REPAIR_MODIF = "CAR_REPAIR_MODIF",
    CAR_REPAIR_CONFIRMED = "CAR_REPAIR_CONFIRMED",
    CAR_REPAIR_ONGOING = "CAR_REPAIR_ONGOING",
    CAR_REPAIR_COMPLETED = "CAR_REPAIR_COMPLETED",

    CAR_CONTROL = "CAR_CONTROL",
    CAR_CONTROL_DRAFT = "CAR_CONTROL_DRAFT",
    CAR_CONTROL_PENDING = "CAR_CONTROL_PENDING",
    CAR_CONTROL_MODIF = "CAR_CONTROL_MODIF",
    CAR_CONTROL_CONFIRMED = "CAR_CONTROL_CONFIRMED",
    CAR_CONTROL_ONGOING = "CAR_CONTROL_ONGOING",
    CAR_CONTROL_COMPLETED = "CAR_CONTROL_COMPLETED",

    POSTING = "POSTING",
    POSTING_TO_PROCESS = "POSTING_TO_PROCESS",
    POSTING_PROCESSED = "POSTING_PROCESSED",

    BUY = "BUY",
    BUY_FAVORITE = "BUY_FAVORITE",
    BUY_DRAFT = "BUY_DRAFT",
    BUY_PENDING = "BUY_PENDING",
    BUY_MODIF = "BUY_MODIF",
    BUY_ONGOING = "BUY_ONGOING",
    BUY_COMPLETED = "BUY_COMPLETED",
    BUY_ALERT = "BUY_ALERT",

    EXCHANGE = "EXCHANGE",
    EXCHANGE_OFFER = "EXCHANGE_OFFER",
    EXCHANGE_DRAFT = "EXCHANGE_DRAFT",
    EXCHANGE_PENDING = "EXCHANGE_PENDING",
    EXCHANGE_PENDING_SENT = "EXCHANGE_PENDING_SENT",
    EXCHANGE_PENDING_RECEIVED = "EXCHANGE_PENDING_RECEIVED",
    EXCHANGE_MODIF = "EXCHANGE_MODIF",
    EXCHANGE_ONGOING = "EXCHANGE_ONGOING",
    EXCHANGE_COMPLETED = "EXCHANGE_COMPLETED",

    INTERM = "INTERM",
    INTERM_OFFER = "INTERM_OFFER",
    INTERM_DRAFT = "INTERM_DRAFT",
    INTERM_PENDING = "INTERM_PENDING",
    INTERM_PENDING_SENT = "INTERM_PENDING_SENT",
    INTERM_PENDING_RECEIVED = "INTERM_PENDING_RECEIVED",
    INTERM_MODIF = "INTERM_MODIF",
    INTERM_ONGOING = "INTERM_ONGOING",
    INTERM_COMPLETED = "INTERM_COMPLETED",
    INTERM_COMMISSION = "INTERM_COMMISSION",

    SELL = "SELL", 
    SELL_OFFER = "SELL_OFFER",
    SELL_PENDING = "SELL_PENDING",
    SELL_ONGOING = "SELL_ONGOING",
    SELL_COMPLETED  = "SELL_COMPLETED",

    RENT_IN = "RENT_IN",
    RENT_IN_FAVORITE = "RENT_IN_FAVORITE",
    RENT_IN_DRAFT = "RENT_IN_DRAFT",
    RENT_IN_PENDING = "RENT_IN_PENDING",
    RENT_IN_MODIF = "RENT_IN_MODIF",
    RENT_IN_CONFIRMED = "RENT_IN_CONFIRMED",
    RENT_IN_COMPLETED = "RENT_IN_COMPLETED",
    RENT_IN_ALERT = "RENT_IN_ALERT",

    RENT_OUT = "RENT_OUT",
    RENT_OUT_OFFER = "RENT_OUT_OFFER",
    RENT_OUT_PENDING = "RENT_OUT_PENDING",
    RENT_OUT_MODIF = "RENT_OUT_MODIF",
    RENT_OUT_CONFIRMED = "RENT_OUT_CONFIRMED",
    RENT_OUT_ONGOING = "RENT_OUT_ONGOING",
    RENT_OUT_COMPLETED = "RENT_OUT_COMPLETED",

    REPAIR = "REPAIR",
    REPAIR_OFFER = "REPAIR_OFFER",
    REPAIR_PENDING = "REPAIR_PENDING",
    REPAIR_MODIF = "REPAIR_MODIF",
    REPAIR_CONFIRMED = "REPAIR_CONFIRMED",
    REPAIR_ONGOING = "REPAIR_ONGOING",
    REPAIR_COMPLETED = "REPAIR_COMPLETED",
    
    CONTROL = "CONTROL",
    CONTROL_OFFER = "CONTROL_OFFER",
    CONTROL_PENDING = "CONTROL_PENDING",
    CONTROL_MODIF = "CONTROL_MODIF",
    CONTROL_CONFIRMED = "CONTROL_CONFIRMED",
    CONTROL_ONGOING = "CONTROL_ONGOING",
    CONTROL_COMPLETED = "CONTROL_COMPLETED",
    
    COMM = "COMM",
    COMM_APPOINTMENT = "COMM_APPOINTMENT",
    COMM_CONVERSATION = "COMM_CONVERSATION",
    COMM_NOTIFICATION = "COMM_NOTIFICATION",
    
    TRANSACTION = "TRANSACTION",
    TRANSACTION_QUOTE = "TRANSACTION_QUOTE",
    TRANSACTION_ONGOING = "TRANSACTION_ONGOING",
    TRANSACTION_COMPLETED = "TRANSACTION_COMPLETED",

    ACCOUNT = "ACCOUNT",
    ACCOUNT_INFO = "ACCOUNT_INFO",
    ACCOUNT_PARAMETERS = "ACCOUNT_PARAMETERS",
    ACCOUNT_CONTRACT = "ACCOUNT_CONTRACT",
    ACCOUNT_PUBLIC = "ACCOUNT_PUBLIC",
    ACCOUNT_SUPPORT = "ACCOUNT_SUPPORT",
    ACCOUNT_SUPPORT_CASE = "ACCOUNT_SUPPORT_CASE",
    ACCOUNT_SUPPORT_FAQ = "ACCOUNT_SUPPORT_FAQ"
};

export class SessionBasicData {
        
    public static sessionMenu: MenuNode[] = [
        //{ code: MenuCode.DASHBOARD, title: 'Tableau de bord', noQuantity: true, link: '/car/dashboard' },
        { 
            code: MenuCode.CAR,
            title: 'Mon parc',
            noQuantity: true,
            link: '/car',
            children: [
                //{ code: MenuCode.CAR_PARK, title: 'Mes véhicules', link: '/car/park' },
                
                { 
                    code: MenuCode.CAR_PARK, 
                    title: 'Mes véhicules', 
                    noQuantity: true,
                    link: '/car/park',
                    children: [
                        { code: MenuCode.CAR_PARK_CARS, title: 'Mes véhicules', link: '/car/park/cars', transactionStages: [TransactionStage.CONFIRMED] },
                        { code: MenuCode.CAR_PARK_POSTING_TO_PROCESS, title: 'Postings a gerer', link: '/car/park/posting-to-process', transactionStages: [TransactionStage.PENDING]},
                        { code: MenuCode.CAR_PARK_POSTING_PROCESSED, title: 'Postings gérés', link: '/car/park/posting-processed', transactionStages: [TransactionStage.COMPLETED] }
                    ]
                },

                /*
                { 
                    code: MenuCode.CAR_REPAIR, 
                    title: 'Réparations', 
                    link: '/car/repair',
                    children: [
                        { code: MenuCode.CAR_REPAIR_PENDING, title: 'A venir', link: '/car/repair/pending' },
                        { code: MenuCode.CAR_REPAIR_CONFIRMED, title: 'Réservations', link: '/car/repair/bookings' },
                        { code: MenuCode.CAR_REPAIR_ONGOING, title: 'En cours', link: '/car/repair/ongoing' },
                        { code: MenuCode.CAR_REPAIR_COMPLETED, title: 'Completées', link: '/car/repair/completed' },
                    ]
                },

                { 
                    code: MenuCode.CAR_CONTROL, 
                    title: 'Contrôles techniques', 
                    link: '/car/control',
                    children: [
                        { code: MenuCode.CAR_CONTROL_PENDING, title: 'A venir', link: '/car/control/pending' },
                        { code: MenuCode.CAR_CONTROL_CONFIRMED, title: 'Réservations', link: '/car/control/bookings' },
                        { code: MenuCode.CAR_CONTROL_ONGOING, title: 'En cours', link: '/car/control/ongoing' },
                        { code: MenuCode.CAR_CONTROL_COMPLETED, title: 'Completées', link: '/car/control/completed' },
                    ]
                },

                { code: MenuCode.CAR_PROVIDERS_FAV, title: 'Prestataires favoris', link: '/car/provider-favorites' },
                { code: MenuCode.CAR_ALERT, title: 'Alertes', link: '/car/alerts' }

                */

            ]
        },

        /*

        { 
            code: MenuCode.EXCHANGE, 
            title: 'Echanges', 
            noQuantity: true,
            link: '/exchange',
            children: [
                { code: MenuCode.EXCHANGE_OFFER, title: 'Mon offre', noQuantity: true, link: '/exchange/offer' },
                //{ code: MenuCode.EXCHANGE_BOOKING, title: 'En attente', link: '/exchange/bookings' },
                { code: MenuCode.EXCHANGE_PENDING_RECEIVED, title: 'Recu en attente', link: '/exchange/bookings/received' },
                { code: MenuCode.EXCHANGE_PENDING_SENT, title: 'Envoyé en attente', link: '/exchange/bookings/sent' },
                { code: MenuCode.EXCHANGE_ONGOING, title: 'En cours', link: '/exchange/ongoing' },
                { code: MenuCode.EXCHANGE_COMPLETED, title: 'Conclus', link: '/exchange/completed' }
            ]
        },

        
        { 
            code: MenuCode.INTERM, 
            title: 'Intermédiations',
            noQuantity: true, 
            link: '/intermediation',
            children: [
                { code: MenuCode.INTERM_OFFER, title: 'Mon offre', noQuantity: true, link: '/intermediation/offer' },
                //{ code: MenuCode.INTERM_BOOKING, title: 'En attente', link: '/intermediation/bookings' },
                { code: MenuCode.INTERM_PENDING_RECEIVED, title: 'Recu en attente', link: '/intermediation/bookings/received' },
                { code: MenuCode.INTERM_PENDING_SENT, title: 'Envoyé en attente', link: '/intermediation/bookings/sent' },
                { code: MenuCode.INTERM_ONGOING, title: 'En cours', link: '/intermediation/ongoing' },
                { code: MenuCode.INTERM_COMPLETED, title: 'Conclus', link: '/intermediation/completed' },
                { code: MenuCode.INTERM_COMMISSION, title: 'Commissions', link: '/intermediation/commissions' }
            ]
        },
        */

       /*

        { 
            code: MenuCode.POSTING, 
            title: 'Postings', 
            noQuantity: true,
            link: '/posting',
            children: [
                { code: MenuCode.POSTING_TO_PROCESS, title: 'A gérer', link: '/posting/to-process', transactionStages: [TransactionStage.PENDING] },
                { code: MenuCode.POSTING_PROCESSED, title: 'Gérés', link: '/posting/processed', transactionStages: [TransactionStage.COMPLETED] },
            ]
        },
        */

        { 
            code: MenuCode.BUY, 
            title: 'Achats', 
            noQuantity: true,
            link: '/buy-in',
            children: [
                { code: MenuCode.BUY_FAVORITE, title: 'Mes Favoris', link: '/buy-in/favorites', transactionStages: [TransactionStage.FAVORITE] },
                { code: MenuCode.BUY_DRAFT, title: 'Brouillons', link: '/buy-in/drafts', transactionStages: [TransactionStage.DRAFT] },
                { code: MenuCode.BUY_PENDING, title: 'Envoyés', link: '/buy-in/sent', transactionStages: [TransactionStage.PENDING] },
                { code: MenuCode.BUY_ONGOING, title: 'En cours', link: '/buy-in/ongoing', transactionStages: [TransactionStage.PENDING, TransactionStage.MODIF, TransactionStage.CONFIRMED]  },
                { code: MenuCode.BUY_COMPLETED, title: 'Conclus', link: '/buy-in/completed', transactionStages: [TransactionStage.COMPLETED]  },
                { code: MenuCode.BUY_ALERT, title: 'Alertes', link: '/buy-in/alerts' }
            ]
        },

        { 
            code: MenuCode.SELL, 
            title: 'Ventes', 
            noQuantity: true,
            link: '/sell',
            children: [
                { code: MenuCode.SELL_OFFER, title: 'Annonces actives', link: '/sell/offer' },
                { code: MenuCode.SELL_PENDING, title: 'Prospects', link: '/sell/prospects'},
                { code: MenuCode.SELL_ONGOING, title: 'En cours', link: '/sell/ongoing' },
                { code: MenuCode.SELL_COMPLETED, title: 'Annonces conclues', link: '/sell/completed' }
            ]
        },

        { 
            code: MenuCode.RENT_IN, 
            title: 'Locations client',
            noQuantity: true,
            link: '/rent-in',
            children: [
                { code: MenuCode.RENT_IN_FAVORITE, title: 'Mes favoris', link: '/rent-in/favorites' },
                { code: MenuCode.RENT_IN_PENDING, title: 'Réservations', link: '/rent-in/bookings' },
                { code: MenuCode.RENT_IN_CONFIRMED, title: 'Locations en cours', link: '/rent-in/ongoing' },
                { code: MenuCode.RENT_IN_COMPLETED, title: 'Locations conclues', link: '/rent-in/completed' },
                { code: MenuCode.RENT_IN_ALERT, title: 'Alertes', link: '/rent-in/alerts' }
            ]
        },

        { 
            code: MenuCode.RENT_OUT, 
            title: 'Locations fourn',
            noQuantity: true, 
            link: '/rent-out',
            children: [
                { code: MenuCode.RENT_OUT_OFFER, title: 'Mes annonces', link: '/rent-out/offer' },
                { code: MenuCode.RENT_OUT_CONFIRMED, title: 'Réservations', link: '/rent-out/bookings' },
                { code: MenuCode.RENT_OUT_ONGOING, title: 'Locations en cours', link: '/rent-out/ongoing' },
                { code: MenuCode.RENT_OUT_COMPLETED, title: 'Locations conclus', link: '/rent-out/completed' }
            ]
        },

        /* 
        { 
            code: MenuCode.REPAIR, 
            title: 'Réparations', 
            noQuantity: true,
            link: '/repair',
            children: [
                { code: MenuCode.REPAIR_OFFER, title: 'Mon offre', noQuantity: true, link: '/repair/offer' },
                { code: MenuCode.REPAIR_CONFIRMED, title: 'Réservations', link: '/repair/booking' },
                { code: MenuCode.REPAIR_ONGOING, title: 'En cours', link: '/repair/ongoing' },
                { code: MenuCode.REPAIR_COMPLETED, title: 'Completées', link: '/repair/completed' },
            ]
        },

        { 
            code: MenuCode.CONTROL, 
            title: 'Contrôles techniques', 
            noQuantity: true,
            link: '/control',
            children: [
                { code: MenuCode.CONTROL_OFFER, title: 'Mon offre', noQuantity: true, link: '/control/offer' },
                { code: MenuCode.CONTROL_CONFIRMED, title: 'Réservations', link: '/control/booking' },
                { code: MenuCode.CONTROL_ONGOING, title: 'En cours', link: '/control/ongoing' },
                { code: MenuCode.CONTROL_COMPLETED, title: 'Completés', link: '/control/completed' },
            ]
        },
        */

        { 
            code: MenuCode.COMM, 
            title: 'Communications',
            noQuantity: true, 
            link: '/communication',
            children: [
                { code: MenuCode.COMM_APPOINTMENT, title: 'Rendez vous', link: '/communication/appointments' },
                { code: MenuCode.COMM_CONVERSATION, title: 'Conversations', link: '/communication/conversations' },
                { code: MenuCode.COMM_NOTIFICATION, title: 'Notifications', link: '/communication/notifications' }
            ]
        },

        /*
        { 
            code: MenuCode.TRANSACTION, 
            title: 'Transactions',
            noQuantity: true, 
            link: '/transactions',
            children: [
                { code: MenuCode.TRANSACTION_QUOTE, title: 'Devis', link: '/transactions/quotes' },
                { code: MenuCode.TRANSACTION_ONGOING, title: 'Paiements en cours', link: '/transactions/pending' },
                { code: MenuCode.TRANSACTION_COMPLETED, title: 'Paiements conclus', link: '/transactions/completed' }
            ]
        },
        */

        { 
            code: MenuCode.ACCOUNT, 
            title: 'Mon compte',
            noQuantity: true,
            link: '/account',
            children: [
                { code: MenuCode.ACCOUNT_INFO, title: 'Mes infos', noQuantity: true, link: '/account/infos' },
                { code: MenuCode.ACCOUNT_PARAMETERS, title: 'Paramètres', noQuantity: true, link: '/account/parameters' },
                { code: MenuCode.ACCOUNT_CONTRACT, title: 'Contrats', link: '/account/contracts' },
                // { code: MenuCode.ACCOUNT_PUBLIC, title: 'Profil public', noQuantity: true, link: '/provider-public' },
                { code: MenuCode.ACCOUNT_PUBLIC, title: 'Profil public', noQuantity: true, link: '/account/public' },
                { code: MenuCode.ACCOUNT_SUPPORT_CASE, title: 'Aide', link: '/account/support/cases' },
                { code: MenuCode.ACCOUNT_SUPPORT_FAQ, title: 'FAQ', noQuantity: true, link: '/account/support/faq' }
            ]
        },
    ];

    public static getChildren(menuCode: MenuCode): MenuNode []{

        let menuItem = this.sessionMenu.find(
            (item) => item.code === menuCode
        )

        return menuItem!.children!
    }

    public static getNode(menuCode: MenuCode): MenuNode {

        let menuItem = this.sessionMenu.find(
            (item) => item.code === menuCode
        )

        return menuItem!
    }
};

